import { useState } from 'react';

import {
  CheckBoxLabelStyled,
  CheckBoxStyled,
  ToggleSwitchWrapperStyled,
} from './ToggleSwitch.styled';

type ToggleSwitchPropsT = {
  id: string;
  name: string;
  checked?: boolean;
  onChange: (val: boolean) => void;
};

const ToggleSwitch: React.FC<ToggleSwitchPropsT> = ({ id, name, checked = false, onChange }) => {
  const [isToggled, setIsToggled] = useState(checked);

  const handleToggle = (val: boolean) => {
    setIsToggled(val);
    onChange(val);
  };

  return (
    <ToggleSwitchWrapperStyled>
      <CheckBoxStyled
        id={id}
        name={name}
        type="checkbox"
        checked={isToggled}
        onChange={() => handleToggle(!isToggled)}
      />
      <CheckBoxLabelStyled htmlFor={id} />
    </ToggleSwitchWrapperStyled>
  );
};

export default ToggleSwitch;
